import { render, staticRenderFns } from "./buttonCTA.vue?vue&type=template&id=4ca9105a&scoped=true&"
import script from "./buttonCTA.vue?vue&type=script&lang=js&"
export * from "./buttonCTA.vue?vue&type=script&lang=js&"
import style0 from "./buttonCTA.vue?vue&type=style&index=0&id=4ca9105a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9105a",
  null
  
)

export default component.exports